import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIncrease: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconIncrease"><Path d="M20.3105 19.25L16.2803 23.2803L15.2197 22.2197L17.4395 20H8V18.5H17.4395L15.2197 16.2803L16.2803 15.2197L20.3105 19.25Z" fill="currentColor"/><Path d="M8.78027 7.71973L7.71973 8.78027L5.5 6.56055V16H4V6.56055L1.78027 8.78027L0.719727 7.71973L4.75 3.68945L8.78027 7.71973Z" fill="currentColor"/><Path d="M20 14H18.5V10H20V14Z" fill="currentColor"/><Path d="M20 8.25H18.5V5.5H15.75V4H20V8.25Z" fill="currentColor"/><Path d="M14 5.5H10V4H14V5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIncrease;
